import { useCallback } from 'react';

import useRequestJSON from './hooks/useRequestJSON';
import { PostJSON, BaseResponse } from './request';
import { AppKey } from './apps';

interface InvalidationConfig {
  [model: string]: {
    keys: [string];
    keyDisplays: Record<string, string>;
  };
}

interface InvalidationResponse {
  config: InvalidationConfig;
}

export interface FieldInvalidation {
  newValue?: number | string | null;
  previousValue?: number | string | null;
  createdAt?: string | Date | null;
}

// Shape depends on the app: single-field apps expose a flat record with
// the base fields below; multi-field apps expose a per-key map of
// `FieldInvalidation`s and omit the base fields. All base fields are
// therefore optional to accommodate both shapes.
export interface Invalidation {
  upper?: FieldInvalidation;
  lower?: FieldInvalidation;
  bpUpper?: FieldInvalidation;
  bpLower?: FieldInvalidation;
  weight?: FieldInvalidation;
  app?: string;
  sessionModel?: string;
  sessionId?: number;
  key?: string;
  value?: string | null;
  newValue?: string | null;
  note?: string | null;
  isVoided?: boolean;
  voidedAt?: string | Date | null;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  deletedAt?: string | Date | null;
  patientId?: number;
  accountId?: number;
  createdById?: number;
  previousValue?: number | string | null;
}

export const useGetInvalidationConfig = (
  appKey: AppKey
): InvalidationResponse => {
  const request = useCallback(
    () =>
      PostJSON({
        url: '/data/data_invalidate_config/',
        params: {
          app: appKey
        }
      }),
    [appKey]
  );
  const { data } = useRequestJSON<InvalidationResponse & BaseResponse>({
    request,
    enabled: appKey != null
  });
  return {
    config: data?.config
  };
};
